<template>
  <div><el-dialog
    title="提示"
    :visible.sync="openNew"
    width="70%"
     >
    <div>
      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="type"
          label="事项类型" align="center"
          width="294">
        </el-table-column>
        <el-table-column
          prop="content"
          label="事项内容" align="center"
          width="696">
        </el-table-column>
        <el-table-column
          prop="create_time"
          label="时间" align="center"
          width="294">
        </el-table-column>
      </el-table>
      <el-pagination style="text-align:right; margin-top: 16px" background layout="prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="openNew = false">取 消</el-button>
      <el-button type="primary" @click="openNew = false">确 定</el-button>
    </span>
  </el-dialog>
  <div class="header_wrap">
    <div class="header clearfix">
      <div :style="{backgroundImage: 'url(' + logo + ')'}"
           class="logo float_left"></div>
      <div class="float_left">
        <el-menu :default-active="menuActive"
                 class="el-menu-demo h_60"
                 mode="horizontal"
                 background-color="#2e5597"
                 text-color="#fff"
                 active-text-color="#2cc6ff">
          <template v-for="item in menuList">
            <el-menu-item :index="item.index"
                          :key="item.router"
                          @click="routerTo(item)">{{item.name}}</el-menu-item>
          </template>

          <el-menu-item @click="routerTo({router:'/dashboard'})"
                        index="4"
                        v-if="isLogin">用户中心</el-menu-item>
          <el-menu-item @click="routerTo({router:'/login'})"
                        v-if="!isLogin"
                        index="5"
                        class="h_60 lh_60">
            登录
          </el-menu-item>
<!--          <div style=" padding-left: 705px;">-->
<!--          <el-menu-item @click="openNew = true"-->
<!--                        v-if="isLogin"-->
<!--                        index="5"-->
<!--                        class="h_60 lh_60"-->
<!--                         style="float: right!important;">-->
<!--            <i class="el-icon-bell" ></i>-->
<!--            <el-badge is-dot class="item" style="margin-top: -20px;margin-left: -10px" v-if="isLogin"></el-badge>-->
<!--          </el-menu-item>-->
<!--          </div>-->
          <!-- <el-dropdown
          >
            <span class="el-dropdown-link">
              <el-menu-item
                @click="routerTo({router:'/login'})"
                v-if="!isLogin"
                index="5"
                class="h_60 lh_60"
              >
                登录
              </el-menu-item>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item>
                <el-button
                  type="text"
                >服务商登录</el-button>
              </el-dropdown-item>
              <el-dropdown-item>
                <div class="flex justify_center">
                  <el-button
                    type="text"
                  >客户登录</el-button>
                </div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown> -->
        </el-menu>
      </div>
      <div v-if="isLogin"
           class="user_area vertical_middle float_right h_60">

        <div class="msg inline_block">

        </div>
        <div style="float: left;margin-right: -25px"  v-if="username == 'admin' ">
          <el-menu :default-active="menuActive"
                   class="el-menu-demo h_60"
                   mode="horizontal"
                   background-color="#2e5597"
                   text-color="#fff"
                   active-text-color="#2cc6ff">
            <template v-for="item in menuList">
              <el-menu-item :index="item.index"
                            :key="item.router"
                            @click="routerTo(item)">{{item.name}}</el-menu-item>
            </template>
            <div>
              <el-menu-item   @click="todo(1)"
                            v-if="isLogin"
                            index="5"
                            class="h_60 lh_60"
                            style="float: right!important;">
                <i class="el-icon-bell" style="color: #ffffff;font-size: 21px" ></i>
                <el-badge is-dot class="item" style="margin-top: -20px;margin-left: -10px" v-if="isLogin"></el-badge>
              </el-menu-item>
            </div>
          </el-menu>
        </div>
        <el-dropdown trigger="click">
          <div class="user_info vertical_middle">
            <img src="/static/img/login_user.png"
                 alt=""
                 class="user_img inline_block">
            <p class="user_name inline_block color_fff">{{user.userName}}</p>
            <div class="arrow_wrap inline_block">
              <i class="el-icon-arrow-down color_fff"></i>
            </div>
          </div>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>
              <el-button @click="changePassword" type="text">修改密码</el-button>
            </el-dropdown-item>
            <el-dropdown-item>
              <el-button @click="handleQuit" type="text">退出</el-button>
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import config from '@/config.js';
export default {
  computed: {
    onRoutes() {
      window.scrollTo(0, 0);
      return this.$route.path.replace("/", "");
    },
  },
  data() {
    return {
      logo: `${config.homeImgBaseUrl}/logo.png`,
      user: {},
      isLogin: false,
      username:"",
      total: 1,
      menuActive: "1",
      openNew:false,
      menuList: [
        // {
        //   name: "首页",
        //   router: "/Home/HomePage",
        //   index: '1',
        // },
        // {
        //   name: "产品",
        //   router: "/Home/Product",
        //   index: '2',
        // },
        // {
        //   name: "服务",
        //   router: "/Home/ServerCenter",
        //   index: '3',
        // },
      ],
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }]
    };
  },
  watch: {
    '$route': 'routerChange',
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem('user')) || '';
    this.isLogin = sessionStorage.getItem('isLogin_admin');
    this.username = this.user ? this.user.getuserName :''
    this.tabChange();
  },
  methods: {
    changePassword() {
      this.$router.push("/changePassword")
    },
    routerChange() {
      // 监听页面变化，找到蓝色下滑线应该在哪里
      this.tabChange();
      // user从服务商变为客户，改变用户昵称
      this.user = JSON.parse(sessionStorage.getItem('user')) || '';
    },
    tabChange() {
      let path = this.$route.path;
      if (path == '/login') {
        this.menuActive = '5';
        return;
      }
      if (path == '/Home/HomePage' || path == '/Home/Us') {
        this.menuActive = '1';
        return;
      }
      if (path == '/Home/Product' || path == '/Home/Logistics') {
        this.menuActive = '2';
        return;
      }
      if (path == '/Home/Tool' || path == '/Home/ServerCenter' ||
        path == '/Home/ServerQuestion' || path == '/Home/NewHandle' ||
        path == '/Home/CooperateOrder') {
        this.menuActive = '3';
        return;
      }
      this.menuActive = '4';
    },
    handleQuit() {
      this.$axios.get("/admin/adminLoginOut").then(res => {
        if(res.data.result == true){
          this.$message(res.data.info)
          this.isLogin = sessionStorage.clear();
          this.$router.push('/login');
        }
      })
    },
    routerTo(item) {
      this.$router.push(item.router);
    },
    todo(pageNum ){
     this.openNew = true;
     debugger
      this.$axios.get("/admin/usertodo/list",{
        params: {
          pageSize: 10,
          pageNum:pageNum,
          username:"admin"
          // username: this.user ? this.user.getuserName :''
        }
      }).then(res => {
        if(res.data.result == true){
          debugger
          let data = res.data.page.list
          this.total = res.data.page.total
          this.tableData = data
        }
      })
    },
    handleCurrentChange(val) {
      this.todo(val)
    },
  }
};
</script>

<style scoped>
.lh_60 {
  line-height: 60px;
}

.logo {
  width: 246px;
  height: 60px;
  margin-right: 20px;
  background-repeat: no-repeat;
  background-position-y: calc((60px - 35px) / 2);
}

.header {
  width: 1200px;
  margin: 0 auto;
}

.user_login {
  padding: 0 20px;
  line-height: 60px;
}

.header_wrap {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 60px;
  background: #2e5597;
  z-index: 100;
}

.h_60 {
  height: 60px;
}

.user_info {
  display: inline-block;
  vertical-align: middle;
  padding: 0 10px;
}

.user_img {
  width: 20px;
  height: 19px;
  vertical-align: middle;
}

.msg {
  position: relative;
  margin: 0 20px;
  vertical-align: middle;
}

.msg_num {
  position: absolute;
  top: 0;
  right: 0;
  width: 22px;
  height: 22px;
  margin-top: -11px;
  margin-right: -11px;
  font-size: 12px;
  line-height: 22px;
  background-color: #e74c3c;
  border-radius: 50%;
}

.user_name {
  margin: 0 5px;
  vertical-align: middle;
}

.arrow_wrap {
  vertical-align: middle;
}
/* .header_wrap {
  padding-right: 40px;
  width: calc(100vw - 40px);
  height: 60px;
}
.header_touxiang {
  width: 30px;
  height: 30px;
  border-radius: 50%;
} */
.
.item {
  margin-left: -10px;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/Header.vue